import React from 'react';
import SingleSlider from './SingleSlider';
import PlantersCategory from './PlantersCategory';
import HomeBanner from './HomeBanner';
import { FiAward, FiGrid, FiShield, FiTruck } from 'react-icons/fi';

const trustPoints = [
  { icon: FiAward, label: 'Premium Quality', sub: 'Built to last' },
  { icon: FiGrid, label: 'Wide Range', sub: 'Everything for your home' },
  { icon: FiShield, label: 'Secure Payments', sub: '100% safe' },
  { icon: FiTruck, label: 'Fast Delivery', sub: 'Pan India' },
];

const HomeBody = () => {
  return (
    <>
      <PlantersCategory title="Shop by category" />

      <SingleSlider slug_name="get_slug_data/planters" title="Planters" cat_slug_name="planters" />

      <HomeBanner
        pageKey="home_middle_1"
        fallbackSrc={`${process.env.PUBLIC_URL}/images/middle1.jpg`}
        className="w-[90%] mx-auto my-10 md:my-14 rounded-2xl shadow-sm"
        alt="Promotional banner"
      />

      <SingleSlider
        slug_name="get_slug_data/bucket"
        title="Buckets"
        cat_slug_name="bucket"
        promo={{
          image: `${process.env.PUBLIC_URL}/images/bucketBanner.jpg`,
          heading: (
            <>
              Strong. <span className="text-brand-600">Durable.</span>
              <br />
              Built for Everyday Needs.
            </>
          ),
          bullets: ['Leak Proof', 'Heavy Duty', 'Long Lasting'],
          buttonText: 'Shop Buckets',
          buttonLink: '/bucket',
        }}
      />

      <HomeBanner
        pageKey="home_middle_2"
        fallbackSrc={`${process.env.PUBLIC_URL}/images/middle1.jpg`}
        className="w-[90%] mx-auto my-10 md:my-14 rounded-2xl shadow-sm"
        alt="Promotional banner"
      />

      <SingleSlider
        title="Fridge Bottle"
        slug_name="get_slug_data/fridge-bottle"
        cat_slug_name="fridge-bottle"
        promo={{
          image: `${process.env.PUBLIC_URL}/images/waterbottle.jpg`,
          heading: (
            <>
              Stay Hydrated
              <br />
              Stay Healthy
            </>
          ),
          description: 'Premium quality fridge bottles',
          buttonText: 'Shop Now',
          buttonLink: '/fridge-bottle',
        }}
      />

      <HomeBanner
        pageKey="home_bottom"
        fallbackSrc={`${process.env.PUBLIC_URL}/images/lastBanner.jpg`}
        className="w-full mt-10 md:mt-14"
        alt="Promotional banner"
      />

      {/* Mobile-only trust section — desktop has no equivalent, left as-is */}
      <div className="md:hidden max-w-7xl mx-auto px-4 mt-10">
        <h2 className="text-lg font-bold text-gray-900 text-center mb-5">Why Choose MPi Shop?</h2>
        <div className="grid grid-cols-2 gap-4">
          {trustPoints.map(({ icon: Icon, label, sub }) => (
            <div key={label} className="flex flex-col items-center text-center gap-1.5 bg-white border border-gray-100 rounded-xl p-4">
              <Icon className="text-brand-600" size={20} />
              <p className="text-xs font-semibold text-gray-800">{label}</p>
              <p className="text-[10px] text-gray-500">{sub}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default HomeBody;
